module.exports = __webpack_public_path__ + "static/media/creditcardbenefits-4.a3fab111.svg";